export const HELP = {
  companyName: {
    title: "Company Name",
    text: "Enter the legal entity name for the ESRS report."
  },
  sector: {
    title: "Sector",
    text: "Select the company sector. This is used for benchmarking and AI context."
  },
  reportingYear: {
    title: "Reporting Year",
    text: "Choose the year covered by the sustainability report."
  },
  governance: {
    title: "Governance",
    text: "Describe governance arrangements relevant to sustainability matters."
  },
  strategy: {
    title: "Strategy",
    text: "Explain how sustainability matters affect business strategy and decision-making."
  },
  iro: {
    title: "Impacts, Risks and Opportunities",
    text: "Summarize the key sustainability impacts, risks, and opportunities identified."
  },
  metricsTargets: {
    title: "Metrics and Targets",
    text: "Describe the metrics and targets used to monitor sustainability performance."
  },
  scope1: {
    title: "Scope 1 Emissions",
    text: "Direct emissions from owned or controlled sources."
  },
  scope2: {
    title: "Scope 2 Emissions",
    text: "Indirect emissions from purchased electricity, steam, heating, or cooling."
  },
  scope3: {
    title: "Scope 3 Emissions",
    text: "All other indirect emissions across the value chain."
  },
  climatePolicies: {
    title: "Climate Policies",
    text: "Describe the company’s climate-related policies, commitments, and management approach."
  },
  workforcePolicies: {
    title: "Workforce Policies",
    text: "Describe policies affecting employees, labor conditions, wellbeing, and rights."
  },
  diversityInclusion: {
    title: "Diversity & Inclusion",
    text: "Describe diversity, inclusion, and equal opportunity measures."
  },
  antiCorruption: {
    title: "Anti-corruption",
    text: "Describe anti-corruption controls, policies, and training."
  },
  whistleblowing: {
    title: "Whistleblowing",
    text: "Describe grievance, whistleblowing, and reporting mechanisms."
  },
  materiality: {
    title: "Double Materiality",
    text: "Assess both impact materiality and financial materiality for each topic."
  },
  stakeholders: {
    title: "Stakeholders Consulted",
    text: "List internal and external stakeholders consulted during the materiality assessment."
  },
  rationale: {
    title: "Rationale",
    text: "Explain why the topic is or is not considered material."
  },
  mdrT: {
    title: "MDR-T",
    text: "Minimum Disclosure Requirement for Targets."
  },
  mdrM: {
    title: "MDR-M",
    text: "Minimum Disclosure Requirement for Metrics."
  }
};